var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1C0.5 0.447715 0.947715 0 1.5 0H3.65287C4.14171 0 4.5589 0.353413 4.63927 0.835601L5.37858 5.27147C5.45075 5.70451 5.23206 6.13397 4.8394 6.3303L3.29126 7.10437C4.40756 9.87832 6.62168 12.0924 9.39563 13.2087L10.1697 11.6606C10.366 11.2679 10.7955 11.0492 11.2285 11.1214L15.6644 11.8607C16.1466 11.9411 16.5 12.3583 16.5 12.8471V15C16.5 15.5523 16.0523 16 15.5 16H13.5C6.3203 16 0.5 10.1797 0.5 3V1Z",
    fill: "#4B5563"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7d06f836.svg";
export { ForwardRef as ReactComponent };